"use client"

import { Package, Truck, CheckCircle, XCircle, User, Clock, Square } from 'lucide-react'; // Import Lucide React icons
import styles from "./StatsCard.module.css"

const StatsCard = ({
  title,
  value,
  change,
  changeType = "positive",
  icon, // This prop can still be used if a custom icon is needed
  iconColor,
  subtitle,
  loading = false,
  onClick,
  className = "",
  ...props
}) => {
  const changeClasses = [
    styles.change,
    changeType === "positive" ? styles.positive : changeType === "negative" ? styles.negative : styles.neutral,
  ]
    .filter(Boolean)
    .join(" ")

  const cardClasses = [styles.card, onClick && styles.clickable, loading && styles.loading, className]
    .filter(Boolean)
    .join(" ")

  // Default icons for different card types using Lucide React
  const getDefaultIcon = (title) => {
    const titleLower = title.toLowerCase();
    if (titleLower.includes("total") || titleLower.includes("device")) {
      return <Package />;
    }
    if (titleLower.includes("available")) {
      return <CheckCircle />;
    }
    if (titleLower.includes("assigned") || titleLower.includes("user")) {
      return <User />;
    }
    if (titleLower.includes("warranty") || titleLower.includes("expir")) {
      return <Clock />;
    }
    // New cases for order stats
    if (titleLower.includes("pending")) {
      return <Package />;
    }
    if (titleLower.includes("shipped")) {
      return <Truck />;
    }
    if (titleLower.includes("delivered")) {
      return <CheckCircle />;
    }
    if (titleLower.includes("cancelled")) {
      return <XCircle />;
    }
    // Default icon
    return <Square />;
  };

  const getIconColor = (title, changeType) => {
    if (iconColor) return iconColor;
    const titleLower = title.toLowerCase();
    if (titleLower.includes("total")) return "#10164D"; // Primary
    if (titleLower.includes("available")) return "#10b981"; // Success
    if (titleLower.includes("assigned")) return "#3b82f6"; // Info
    if (titleLower.includes("warranty")) return "#f59e0b"; // Warning
    // New cases for order stats (matching colors from OrdersPage.js)
    if (titleLower.includes("pending")) return "#3b82f6"; // Blue
    if (titleLower.includes("shipped")) return "#10b981"; // Green
    if (titleLower.includes("delivered")) return "#06b6d4"; // Cyan
    if (titleLower.includes("cancelled")) return "#ef4444"; // Red
    return "#6b7280"; // Default gray
  };

  const displayIcon = icon || getDefaultIcon(title);
  const displayIconColor = getIconColor(title, changeType);

  return (
    <div
      className={cardClasses}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      {...props}
    >
      {loading && <div className={styles.loadingOverlay} />}
      <div className={styles.header}>
        <div className={styles.titleSection}>
          <h3 className={styles.title}>{title}</h3>
        </div>
        {displayIcon && (
          <div className={styles.iconContainer} style={{ color: displayIconColor }}>
            {displayIcon}
          </div>
        )}
      </div>
      <div className={styles.content}>
        <div className={styles.value}>{loading ? "..." : value}</div>
        {/* {change && (
          <div className={changeClasses}>
            {changeType === "positive" && "↗ "}
            {changeType === "negative" && "↘ "}
            {change}
          </div>
        )} */}
      </div>
    </div>
  );
};

export default StatsCard;
